import React, {useState} from 'react'
import ModalContainer from './ModalContainer'
import ModalButton from './Buttons/normal/ModalButton'
import Colors from '../../colors'
import MultilineInput from '../MultilineInput'

function ErrorModal({ isVisible, setIsVisible, dataCallback }) {

    const [errMsg, setErrMsg] = useState()
    const [text, setText] = useState()

    const handleSubmit = () => {
        if (!text || text.length === 0) {
            setErrMsg('Error description can not be empty')
            return;
        }
        setIsVisible(false);
        dataCallback(text);
    }

    return (
        <ModalContainer title={'Report Recurring Issue'} isVisible={isVisible} setIsVisible={setIsVisible} style={{padding: 22}}>
            <MultilineInput label={'Error description'} maxChars={500} placeholder={'Enter error description...'} setText={setText} value={text} />
            <ModalButton color={Colors.green} onClick={handleSubmit}>Report</ModalButton>
            { errMsg && <span style={{color: 'red'}}>{errMsg}</span> }
        </ModalContainer>
    )
}

export default ErrorModal